<aside class="noticia-destaque" aria-labelledby="noticia-destaque-titulo">
  <h2 class="noticia-destaque-titulo" id="noticia-destaque-titulo">
    <span class="noticia-destaque-etiqueta">Destaque</span>
    <span class="noticia-destaque-complemento">notícias</span>
  </h2>

  <ul class="noticia-destaque-lista">
    @for (noticia of destaques(); track noticia.id) {
      <li class="noticia-destaque-item">
        <a class="noticia-destaque-link" [routerLink]="rota(noticia)">
          <span class="noticia-destaque-imagem-wrap">
            <img class="noticia-destaque-imagem" [ngSrc]="noticia.imagem" fill alt="" />
          </span>

          <span class="noticia-destaque-conteudo">
            @if (noticia.categoria; as categoria) {
              <span class="noticia-destaque-badge" [style.background]="categoria.cor">
                {{ categoria.rotulo }}
              </span>
            }

            <span class="noticia-destaque-item-titulo">{{ noticia.titulo }}</span>

            <span class="noticia-destaque-data">
              <i-lucide name="calendar" size="13" aria-hidden="true"></i-lucide>
              {{ noticia.data | dataNoticia }}
            </span>
          </span>
        </a>
      </li>
    }
  </ul>
</aside>
